export default {

    situacao: [
        { text: "Diversos", val: "1" },
        { text: "Urgente", val: "U" },
        { text: "Plantão", val: "P" },
        { text: "Novas Instalações", val: "S" },
        { text: "Alterações SAGE", val: "3" },
        { text: "Vendas", val: "5" },
        { text: "Visitas", val: "6" },
        { text: "Projetos WEB", val: "8" },
    ],

    modulos: [
        { text: "Todos", val: "" },
        { text: "SAGEW", val: "SAGEW" },
        { text: "CAIXAW", val: "CAIXAW" }],

    status: [
        { text: "Bloquear", val: "999" },
        { text: "Liberar", val: "000" },
        { text: "Aviso atraso", val: "100" }]
}